"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _HelpText = _interopRequireDefault(require("./HelpText"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 50px;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledLoadingContainer = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "LoadingContainer__StyledLoadingContainer",
  componentId: "sc-1pi1j50-0"
})(_templateObject());

var LoadingContent = _styledComponents.default.div.withConfig({
  displayName: "LoadingContainer__LoadingContent",
  componentId: "sc-1pi1j50-1"
})(_templateObject2());

var LoadingContainer = function LoadingContainer(_ref) {
  var displayHelpText = _ref.displayHelpText;
  return _react.default.createElement(StyledLoadingContainer, {
    align: "center",
    direction: "column",
    justify: "center"
  }, _react.default.createElement(LoadingContent, null, _react.default.createElement(_UILoadingSpinner.default, {
    layout: "centered",
    showLabel: displayHelpText,
    label: _HelpText.default
  })));
};

var _default = LoadingContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/components/StyledComponents/LoadingContainer.js
// module id = 277
// module chunks = 0